const _directiveDependencies = [];
const _controllerDependencies = ['$timeout'];

class DownloadTooltipController {

    constructor($timeout) {

        this.$timeout = $timeout;
        this.isNotificationVisible = false;

    }

}


class DownloadTooltipDirective {

    constructor() {

        this.template = require('./download-tooltip.html');
        this.restrict = 'E';
        this.replace = true;

        _controllerDependencies.push($timeout =>
            new DownloadTooltipController($timeout));
        this.controller = _controllerDependencies;
        this.controllerAs = 'DownloadTooltipCtrl';

    }

}

_directiveDependencies.push(() => new DownloadTooltipDirective());

angular.module('directives')
    .directive('downloadTooltip', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/download-tooltip/download-tooltip.js